export const TERMS_AND_CONDITIONS =
  "1. All disputes are subject to Jaipur jurisdiction only";
export const GSTIN = "24AAACQ1234567890";
export const IFSC = "ICIC05636748";
export const ACCOUNT_NO = "135890004532";
export const BANK_NAME = "ICICI Bank";
export const BRANCH_NAME = "JLN Marg Jaipur";
export const OTP_EXPIRATION_TIME = 5 * 60; // 5 minutes

export const PickupAddress = {
  postcode: "410206",
  address: "Sweetz n Snackz, shop no 2,3,4 , Landmark Luxuria, Sector 23",
  contact: "8097968992",
  name: "Sweetz n Snackz",
  email: "sweetznsnackz@gmail.com",
  city: "Mumbai",
  state: "Maharashtra",
};

// Add enum for coupon types
export const CouponType = {
  PUBLIC_MULTI_USE: "A", // Public, multiple uses per user
  REGISTERED_SINGLE_USE: "B", // Registered users only, one use per user
  USER_SPECIFIC: "C", // Specific users only
  UNIQUE_SINGLE_USE: "D", // One-time use globally
};

